"use client";

import { usePathname } from "next/navigation";
import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";

export function useIsGenieEnabled(): boolean {
  const pathname = usePathname();
  const onAppDeployment =
    !!pathname &&
    (pathname.includes("/apps/f/") ||
      pathname.includes("/apps/c/") ||
      pathname.includes("/apps/d/"));
  const { data: betaFeatures } = useRemoteData(
    DATA_KEYS.BETA_FEATURES,
    {},
    { enabled: !onAppDeployment, staleTime: 60_000 }
  );
  return !onAppDeployment && !!betaFeatures?.includes("genie");
}
